
<!--begin header -->
<header class="header">
    <app-header></app-header>
</header>
<section>
    <!--begin services-wrapper -->
   
        <br />
        <br />
        <br />
        <br />
        <br />
        <div class="banner_image">
          <img src="./assets/images/make_my_trip_banner.png" alt="Image Description" />
        </div>

        <h2 class="subheading">What is SingX:</h2>
        <p class="paragraph">
            SingX is your trusted partner for secure, transparent, and low-cost international money transfers. 
            Join thousands who rely on us to send money worldwide with no hidden fees-just simple, seamless remittances 
            to loved ones around the globe.
        </p>

        <p class="paragraph">
            <strong>Limited time offer:</strong> Sign up and remit with SingX to enjoy exclusive discounts on MakeMyTrip.
        </p>

        <div class="button-wrapper">
            <a class="btn getStarted" href="https://app.singx.co/register?country=sg" target="_blank">
                Sign Up to Claim Your Discount
            </a>
        </div>

        <div class="offer-details">
            <h2><strong>Offer Details:</strong></h2>
            <ul style="list-style-type: disc;">
                <li style="list-style-type: disc;">
                    <strong>Flights:</strong> Originating from Singapore​
                    <ul style="list-style-type: disc;">
                        <li style="list-style-type: disc;">5% off on Economy Fares</li>
                        <li style="list-style-type: disc;">8% off on Premium Economy & Business Fares</li>
                    </ul>
                </li>
                <li style="list-style-type: disc;">
                    <strong>Hotels Worldwide:</strong> Up to 15% off.
                </li>
            </ul>
        </div>

        <div class="terms-conditions">
            <h2>Terms and Conditions:</h2>
            <ul style="list-style-type: disc;">
                <li style="list-style-type: disc;">Promotion is valid for residents of Singapore only.</li>
                <li style="list-style-type: disc;">The offer is applicable on flights originating from Singapore to all sectors.</li>
                <li style="list-style-type: disc;">The minimum Average Transaction Value (ATV) for airline bookings is SGD 400 for all classes of flights.</li>
                <li style="list-style-type: disc;">There is No minimum Average Transaction Value (ATV) for hotel bookings.</li>
                <li style="list-style-type: disc;">Hotel discounts are capped at SGD 150 per offer redemption.</li>
                <li style="list-style-type: disc;">SingX is not liable for any loss, theft, or unauthorized use related to this promotion.</li>
                <li style="list-style-type: disc;">SingX and MakeMyTrip have the right to withdraw/alter this promotion without any prior notice.</li>
                <li style="list-style-type: disc;">Users must complete a transaction with SingX to qualify.</li>
            </ul>
        </div>


        <div class="button-row">
           
                <a class="btn getStarted" href="https://app.singx.co/login?country=sg" target="_blank">Login</a>
        
                <a class="btn getStarted" href="https://app.singx.co/register?country=sg" target="_blank">
                    Sign Up to Claim Your Discount
                </a>
        
        </div>
     
  </section>

      <!-- footer -->
      <app-footer></app-footer>